<ion-header>

    <ion-toolbar>
        <ion-title>{{toUser.name}}</ion-title>
        <ion-buttons slot="primary">
            <ion-button (click)="dismiss()" slot="end">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <div class="message-wrap">

        <div *ngFor="let msg of msgList"
             [class.left]=" msg.userId === toUser.id "
             [class.right]=" msg.userId === user.id "
             class="message">
            <img [src]="msg.userAvatar" alt="" class="user-img" src="">
            <ion-spinner *ngIf="msg.status === 'pending'" name="dots"></ion-spinner>
            <div class="msg-detail">
                <div class="msg-info">
                    <p>
                        {{msg.userName}}&nbsp;&nbsp;&nbsp;{{msg.time | relativeTime}}</p>
                </div>
                <div class="msg-content">
                    <span class="triangle"></span>
                    <p class="line-breaker ">{{msg.message}}</p>
                </div>
            </div>
        </div>

    </div>

</ion-content>

<ion-footer class="ion-no-border">
    <div class="input-wrap">
        <ion-button (click)="switchEmojiPicker()" fill="clear" slot="end">
            <ion-icon slot="icon-only" name="happy"></ion-icon>
        </ion-button>
        <ion-textarea #chat_input
                  (focusin)="onFocus()"
                  (keyup.enter)="sendMsg()"
                  [(ngModel)]="editorMsg"
                  placeholder="Nachricht...">
    </ion-textarea>
        <ion-button (click)="sendMsg()" fill="clear" slot="end">
            <ion-icon  slot="icon-only" name="send"></ion-icon>
        </ion-button>
    </div>
    <emoji-picker *ngIf="showEmojiPicker" [(ngModel)]="editorMsg"></emoji-picker>
</ion-footer>
